/**
 * Homepage hero — first-party WebP in `public/images/` (responsive widths).
 * `srcset` keeps mobile decode/transfer small for better LCP vs a single 1280w file.
 */
export const HERO_PUBLIC_PATH_640 = '/images/hero-home-lcp-640.webp';
export const HERO_PUBLIC_PATH_960 = '/images/hero-home-lcp-960.webp';
export const HERO_PUBLIC_PATH_1280 = '/images/hero-home-lcp.webp';

/** Default `src` for older browsers; primary selection comes from `srcSet`. */
export const HERO_PUBLIC_PATH = HERO_PUBLIC_PATH_960;

export const HERO_WEBP_SRCSET = [
  `${HERO_PUBLIC_PATH_640} 640w`,
  `${HERO_PUBLIC_PATH_960} 960w`,
  `${HERO_PUBLIC_PATH_1280} 1280w`,
].join(', ');

export const HERO_IMAGE_SIZES = '100vw';

/** Largest variant for Open Graph / Twitter (absolute URL built in HomePage). */
export const HERO_OG_PATH = HERO_PUBLIC_PATH_1280;

function escapeHtmlAttr(value: string): string {
  return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
}

/**
 * Early LCP preload (injected into `index.html` via Vite `transformIndexHtml`).
 * `imagesrcset` + `imagesizes` lets the browser fetch an appropriate width immediately.
 */
export function getHeroPreloadLinkTag(): string {
  const href = escapeHtmlAttr(HERO_PUBLIC_PATH_960);
  const srcset = escapeHtmlAttr(HERO_WEBP_SRCSET);
  const sizes = escapeHtmlAttr(HERO_IMAGE_SIZES);
  return `<link rel="preload" as="image" type="image/webp" fetchpriority="high" href="${href}" imagesrcset="${srcset}" imagesizes="${sizes}" />`;
}
